import React from 'react';
import RefreshIcon from '@mui/icons-material/Refresh';
import SyncIcon from '@mui/icons-material/Sync';
import HLButton from 'components/HLButton';
import { HrRefreshHistoryStatus } from 'pages/Dashboard/types/healthRecords.types';

interface HealthRecordRefreshProps {
  handleRecordRefreshDrawer: () => void;
  refreshStatus?: HrRefreshHistoryStatus;
  isDisabled?: boolean;
  isFetchingHR?: boolean;
}

function HealthRecordRefresh({
  handleRecordRefreshDrawer,
  isDisabled,
  refreshStatus,
  isFetchingHR,
}: HealthRecordRefreshProps) {
  const isRefreshing = refreshStatus === HrRefreshHistoryStatus.IN_PROGRESS || isFetchingHR;
  const text = isRefreshing ? 'Refresh in progress' : 'Health Record Refresh';
  const Icon = isRefreshing ? SyncIcon : RefreshIcon;
  const iconSx = isRefreshing ? {
    animation: 'spin 2s infinite linear',
    '@keyframes spin': {
      '0%': {
        transform: 'rotate(0deg)',
      },
      '100%': {
        transform: 'rotate(360deg)',
      },
    } } : {};
  return (
    <HLButton
      onClick={() => handleRecordRefreshDrawer()}
      variant='outlined'
      disabled={isDisabled}
      fullWidth
      startIcon={<Icon fontSize='large' sx={iconSx} />}
    >
      {text}
    </HLButton>
  );
}

export default HealthRecordRefresh;
